module.exports = __webpack_public_path__ + "img/defultbg2@3x.aa69aa55.png";